
/**
 * Renders the icon passed as prop. You can to style it by passing more props: Color, Size, and Opacity.
 * @displayName FixitIcon
 */
export default {
    name: 'FIcon',
    props: {
        color: {
            type: String,
            default: '#000000'
        },
        size: {
            type: String,
            default: '24px'
        },
        icon: {
            type: String,
            default: ''
        },
        opacity: {
            type: String,
            default: '100%'
        },
    },
    computed: {
        iconId() {
            return this.icon.startsWith("icon-") ? this.icon + Math.floor(Math.random() * 100000) : 'icon-' + this.icon + Math.floor(Math.random() * 100000);
        },
        iconColor() {
            switch (this.color) {
                case 'primary':
                    return 'var(--v-primary-base)';
                    break;
                case 'secondary':
                    return 'var(--v-secondary-base)';
                    break;
                default:
                    return this.color;
            }
        }
    },
    mounted() {
        let icon = document.getElementById(`${this.iconId}`)
        if (this.size.includes("px")) icon.style.fontSize = this.size
        else icon.style.fontSize = (parseFloat(this.size) * 24).toString() + "px"
        icon.style.opacity = this.opacity
        
        //Set the color
        var sheet = (function() {
            var style = document.createElement("style");
            style.appendChild(document.createTextNode(""));
            document.head.appendChild(style);
            return style.sheet;
        })();
        sheet.insertRule(`#${this.iconId}:before { color: ${this.iconColor}; }`, 0);
    }
}
